module.exports = __webpack_public_path__ + "static/2-fce77db9ca8b3cb3226e7b06e0557181.jpeg";